/* eslint-disable jsx-a11y/img-redundant-alt */
import { useEffect, useState } from 'react';
import Banner from '../components/Home/Banner';
import Intro from '../components/Home/Intro';
import Info from '../components/Home/Info';
import { Segment } from '@mui/icons-material';
import SegmentCard from '../components/SegmentCard/SegmentCard';
import { Link } from 'react-router-dom';

const Home = () => {
  const [homeData, setHomeData] = useState({});

  const getData = async () => {
    try {
      const data = await fetch('json/home.json');
      const objData = await data.json();
      if (objData) setHomeData(objData);
    } catch (error) {
      // console.log(error)
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <main className="flex container mx-auto flex-col items-center justify-center">
        <section className="relative w-full min-h-screen mb-8 flex flex-col md:flex-row justify-center md:justify-between items-center pt-[90px] over">
          <h1 className="md:hidden tracking-wide lg:tracking-widest text-2xl 2xl:text-3xl w-fit  font-medium text-center md:text-left">
            Welcome to
          </h1>
          <div className=" flex flex-col md:max-w-[40vw] lg:max-w-[35vw] items-center md:items-start md:gap-1 order-2 md:order-1">
            <h1 className="md:block hidden tracking-wide lg:tracking-widest text-2xl 2xl:text-3xl w-fit  font-medium text-center md:text-left">
              Welcome to
            </h1>
            <h1 className="md:block hidden tracking-wide lg:tracking-widest text-5xl 2xl:text-7xl  font-medium text-center md:text-left text-black">
              <span className="text-primary">INIT</span> 4.0
            </h1>
            <img
              src={'/Images/schedule.svg'}
              alt={'Image'}
              className="relative w-full max-w-[95%] md:max-w-[450px] mt-3 mb-2"
            />
            <p className="mt-3 text-base 2xl:text-[1.375rem]   2xl:leading-8  break-words w-[85vw] md:w-fit text-center md:text-left Nunito">
              Get ready to shake off the ordinary and dive into an exciting new world with INIT 4.0!
              Brought to you by the Notre Dame Information Technology Club.
            </p>

            <a
              href="/about"
              className="hover:border-secondary_light before:ease relative flex items-center justify-center  overflow-hidden shadow-2xl transition-all before:absolute before:top-1/2 before:h-0 before:w-64 before:origin-center before:-translate-x-20 before:rotate-45 before:bg-secondary_light before:duration-300 hover:shadow-secondary_light hover:text-primary_dark hover:before:h-64 hover:before:-translate-y-32 Bebas text-xl mt-5 py-2 font-Bebas px-7 me-2 mb-2 font-medium text-whiterounded-lg border focus:z-10 focus:ring-4  focus:ring-primary bg-primary text-white border-primary  hover:bg-zinc-700 rounded-lg"
            >
              <span className="relative z-10">REGISTER NOW</span>
            </a>
          </div>
          <img
            src={'/Images/bg.png'}
            alt={'Image'}
            className="relative w-[80%] xsm:w-[65%] mb-4 md:mb-0 md:w-[45%] max-w-[500px] md:max-h-[70vh] object-contain order-1 md:order-2"
            width={850}
            height={850}
          />
          {/* <img src="/Images/bg.png" className="absolute bottom-[-4vh] right-0 -z-10" alt="" /> */}
        </section>
        <section className="w-screen bg-image bg-no-repeat bg-cover bg-bottom  relative my-auto">
          {' '}
          <section className="flex flex-col container items-center my-auto">
            <div className="flex flex-col-reverse md:flex-row gap-8 text-[#ffffffbe] text-base 2xl:text-lg Nunito py-12 items-center">
              <div className="flex-1 py-5">
                <h1 className="text-[2.55rem] md:text-5xl mb-5 text-white">
                  ABOUT <span className="text-secondary">INIT 4.0</span>
                </h1>
                <p className="flex-1">
                  NDITC INIT 4.0 is set to blow your mind with a lineup of thrilling events designed
                  to challenge and inspire. Whether you're into the high-energy action of Robo Wars
                  or the brain-teasing puzzles of Programming Contests, there's something here for
                  every tech enthusiast. And if sports are more your style, we've got unique twists
                  like Spot N Go and Soccer Wheels to get your heart pumping and your competitive
                  spirit soaring. But wait, there's more! We've pulled out all the stops to make
                  NDITC INIT 4.0 an unforgettable experience. Get ready for amazing prizes that'll
                  leave you speechless and bragging rights that'll make your friends jealous. So,
                  mark May 2–May 4, 2023, on your calendars, as NDITC INIT 4.0 is set to deliver to
                  you one of the county's top college-level technology-based festivals, and it's
                  going to be epic.
                </p>
              </div>
              <div className="w-full flex-1 md:w-1/2 rounded-xl h-full shadow">
                <img
                  className="w-full object-cover  md:min-h-[410px] max-h-[50vh]  rounded-xl h-full"
                  src="/Images/abt.jpg"
                  alt=""
                ></img>
              </div>
            </div>
          </section>
        </section>

        <div className="w-screen h-fit pt-16 pb-16 object-cover bg-[#f6f6f6] text-center">
          <h1 className="mx-auto mb-5 md:mb-8 ">
            <span className="text-4xl md:text-5xl text-center">WE HAVE </span>{' '}
            <br className="inline md:hidden" />
            <span className="text-primary text-4xl md:text-5xl text-center">SEGMENTS </span>{' '}
            <span className="text-4xl md:text-5xl text-center">ON </span>
          </h1>
          <div className="container grid-fluid-fill-[280px] grid gap-8">
            {[...new Array(4)].map(() => (
              <SegmentCard
                title="PROJECT DISPLAY"
                imageURL={'/Images/abt.jpg'}
                shortDesc={'Show your amazing projects here and get your reward.'}
              />
            ))}
          </div>
          <div className="w-full  container flex justify-center mt-4">
            <Link to="/events">
              <a className="hover:border-secondary_light before:ease relative flex items-center justify-center  overflow-hidden shadow-2xl transition-all before:absolute before:top-1/2 before:h-0 before:w-64 before:origin-center before:-translate-x-20 before:rotate-45 before:bg-secondary_light before:duration-300 hover:shadow-secondary_light hover:text-primary_dark hover:before:h-96 hover:before:-translate-y-32 Bebas text-xl mt-5 py-2 font-Bebas px-7 me-2 mb-2 font-medium text-whiterounded-lg border focus:z-10 focus:ring-4  focus:ring-primary bg-primary text-white border-primary  hover:bg-zinc-700 rounded-lg">
                <span className="relative z-10">EXPLORE MORE EVENTS →</span>
              </a>
            </Link>
          </div>
        </div>
        <div className="w-screen h-fit pt-16 pb-16 object-cover  text-center">
          <div className="container">
            <h1 className="mx-auto mb-5 md:mb-8 ">
              <span className="text-4xl md:text-5xl text-center">RULES & </span>{' '}
              <br className="inline md:hidden" />
              <span className="text-primary text-4xl md:text-5xl text-center">
                ELEGIBILITY{' '}
              </span>{' '}
            </h1>
            <p className="text-left">
              Participants eligible for the competition include all current students enrolled in
              schools, colleges, and corresponding institutions, including those from the HSC batch
              of 2024. Individual participation is mandatory, and submissions must adhere to
              provided guidelines, ensuring originality and compliance with copyright laws. Fair
              play and respectful conduct are expected throughout the competition, with any form of
              cheating or inappropriate behavior resulting in disqualification. Participants must
              also comply with all applicable laws and regulations and respect judges' decisions,
              while organizers reserve the right to disqualify any participant violating rules or
              failing to adhere to guidelines. Changes to rules may occur at organizers' discretion,
              communicated through official channels, and participants' agreement to abide by these
              rules and additional guidelines is implied upon participation.
            </p>
          </div>
        </div>
      </main>
    </>
  );
};

export default Home;
